import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-colored-label',
    templateUrl: './app-colored-label.component.html',
    styleUrls: ['./app-colored-label.component.scss'],
    preserveWhitespaces: true,
    providers: []
})
export class AppColoredLabelComponent {

    @Input() bgColor = '#ffffff';
    @Input() textColor = '#000000';
    @Input() text = '';

    constructor() {
    }

}


// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/components/app-colored-label/app-colored-label.component.ts